import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../utils/api';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';

export const extendedApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    getAreaTax: build.query({
      query: (args) => {
        if (args) {
          const { page, perPage, searchParams = '', id } = args;
          return `${apiUrl.areaTaxHistory}/areaTaxLocationId/${id}?perPage=${perPage || DEFAULT_PER_PAGE}&page=${
            page || DEFAULT_PAGE
          }&${searchParams}`;
        }
        return `${apiUrl.areaTaxHistory}`;
      },
      transformResponse: (responseData) => responseData,
      providesTags: ['AreaTax'],
    }),
    createAreaTax: build.mutation({
      query: (data) => ({
        url: `${apiUrl.areaTaxHistory}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['AreaTax', 'ManageAreaTaxLocations'],
    }),
    deleteAreaTax: build.mutation({
      query: (data) => ({
        url: `${apiUrl.areaTaxHistory}`,
        method: 'DELETE',
        body: data,
      }),
      invalidatesTags: ['AreaTax', 'ManageAreaTaxLocations'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetAreaTaxQuery, useGetAreaTaxByIdQuery, useCreateAreaTaxMutation, useDeleteAreaTaxMutation } =
  extendedApi;
